const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'DESERIALIZER_INDEXING': {
      const payloadType = action.payload.payloadIndices.type
      if (
        action.payload.view !== 'assignmentsView' ||
        (payloadType !== 'phase_item' && payloadType !== 'assignment')
      ) {
        return state
      }
      const payloadIndices = action.payload.payloadIndices
      const newEntityIds = payloadIndices.ids
      const hasCurrentEntityIds =
        state !== undefined && state[payloadType] !== undefined
      const currentEntityIds = hasCurrentEntityIds ? state[payloadType] : []

      /**
     Using a set will ensure the result is deduped
     This is redundant in some cases (like pagination),
     but necessary in other cases (such as when updating a single assignment) -
     in those cases, the id of the new fetched assignment will already be in the array
     and should not be duplicated
     */
      const set = new Set([...currentEntityIds, ...newEntityIds])
      return {
        ...state,
        [payloadType]: Array.from(set),
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
